module.exports = __webpack_public_path__ + "static/media/pet-policy1.11337f05.svg";